export const editableCellLocale = {
  en: {
    invalidEmail: 'Please enter a valid email address',
    invalidPhoneNumber: 'Please enter a valid phone number',
    saveFailed: 'Could not save the change. Please try again.',
    saveThrottled: 'Saving too quickly — please try again',
    selectAll: 'Select all',
    clearSelection: 'Clear selection',
    noUser: 'No user',
    noOption: 'None',
    noFile: 'No file',
    noFiles: 'No files',
    fileCount: '{count} Files',
    dropzone: 'Click to choose a file or drag and drop here',
    searchPlaceholder: 'Search…',
    copy: 'Copy',
    copied: 'Copied to clipboard',
    sendEmail: 'Send email',
    invalid_email: 'Invalid email address',
    invalid_phone_number: 'Invalid phone number',
    invalid_date: 'Invalid date',
    invalid_option: 'Invalid option',
    invalid_user: 'Invalid user',
    invalid_file: 'Invalid file',
    invalid_number: 'Invalid number',
    invalid_decimal: 'Invalid number',
    numberTooLarge: 'This number is too large',
    numberTooPrecise: 'Up to 10 decimal places',
    noResults: 'No results',
    loadingOptions: 'Loading options…',
    loadOptionsError: 'Could not load options — click to retry',
    removeFile: 'Remove {name}',
  },
};
